import { Controller } from "stimulus"

export default class extends Controller {

  refresh() {
    setTimeout(function() { document.location = window.location.href}, 2000)
  }

}
